import BaseAPI from '../api'

const path = 'stalls-list'

export default class StallsListApi extends BaseAPI {

    static stallsList(props: any): Promise<any> {
        return this.api.get(path, { params: { ...props } }).then((res) => res)
    }
    static zoneList(props: any): Promise<any> {
        return this.api.get(`${path}/zone`, { params: { ...props } }).then((res) => res)
    }


    static create(payload: any): Promise<any> {
        return this.api.post(`${path}`, payload)
    }
    static createZone(payload: any): Promise<any> {
        return this.api.post(`${path}/zone`, payload)
    }
    static findZoneById(id: number): Promise<any> {
        return this.api.get(`${path}/zone/${id}`).then((res) => res)
    }
    static updateZone(payload: any, id: any): Promise<any> {
        return this.api.patch(`${path}/zone/${id}`, payload)
    }
    static findById(id: number): Promise<any> {
        return this.api.get(`${path}/${id}`).then((res) => res)
    }

    static update(id: number, body: any): Promise<any> {
        return this.api.patch(`${path}/${id}`, body)
    }
    static qr(id: number, stallId: any): Promise<any> {
        return this.api.get(`${path}/${stallId}/meter/${id}`)
    }


    static delete(id: number): Promise<any> {
        return this.api.delete(`${path}/${id}`)
    }


}